import { Link } from "gatsby";
import ContentRef from "../../../../src/components/ContentRef";
import SectionTitle from "../../../../src/components/SectionTitle";
import * as React from 'react';
export default {
  Link,
  ContentRef,
  SectionTitle,
  React
};